import { HiOutlineHome } from "react-icons/hi";
import { SiYourtraveldottv } from "react-icons/si";
import { BiReceipt } from "react-icons/bi";
import {
  FaBlog,
  FaCalendarAlt,
  FaEvernote,
  FaNewspaper,
  FaPersonBooth,
  FaProjectDiagram,
  FaRegQuestionCircle,
  FaStarHalfAlt,
  FaUserGraduate,
} from "react-icons/fa";
import { FaUserFriends } from "react-icons/fa";
import { FaSortNumericDownAlt } from "react-icons/fa";
import classes from "../../layouts/sideBar/sidebar.module.css";

const sideBarAdmin = {
  list: [
    {
      title: "Dashboard",
      icon: <HiOutlineHome className={classes.icon} />,
      route: "/admin/dashboard",
    },
    {
      title: "Programs",
      icon: <SiYourtraveldottv className={classes.icon} />,
      route: "/admin/programs",
    },
    {
      title: "Users",
      icon: <FaUserFriends className={classes.icon} />,
      route: "/admin/users",
    },

    {
      title: "Blog",
      icon: <FaBlog className={classes.icon} />,
      route: "/admin/blogs",
    },
    {
      title: "News Letter",
      icon: <FaNewspaper className={classes.icon} />,
      route: "/admin/newsletter",
    },
    {
      title: "Special Requests",
      icon: <FaRegQuestionCircle className={classes.icon} />,
      route: "/admin/special-requests",
    },
    {
      title: "Reviews",
      icon: <FaStarHalfAlt className={classes.icon} />,
      route: "/admin/reviews",
    },
    {
      title: "Capacity Building",
      icon: <FaProjectDiagram className={classes.icon} />,
      route: "/admin/capacity-projects",
    },
    {
      title: "Careers",
      icon: <FaUserGraduate className={classes.icon} />,
      route: "/admin/careers",
    },
    {
      title: "Events",
      icon: <FaCalendarAlt className={classes.icon} />,
      route: "/admin/events",
    },
    {
      title: "Teams",
      icon: <FaPersonBooth className={classes.icon} />,
      route: "/admin/team",
    },
    {
      title: "Counter",
      icon: <FaSortNumericDownAlt className={classes.icon} />,
      route: "/admin/counter",
    },
  ],
};

export default sideBarAdmin;
